/* ═══════════════════════════════════════════════════
   Ranitas 🐸 — theme.js (tema Shopify "Aliperuvian")
   Adaptación del script original de croky-web/index.html:
   - CONFIG se lee de window.RANITAS_CONFIG (lo inyecta layout/theme.liquid
     desde los settings del tema: whatsapp, tiktok, correoResenas, precioBase).
   - Los thumbs de la galería del hero y las reseñas del hero (#htData)
     vienen pre-renderizados por Liquid; el JS solo los conecta.
   - Los precios del bundle y del sticky se leen de data-attributes
     (data-qty, data-price, data-price-label, data-old, data-off).
   - Inits idempotentes por componente (dataset.rinit) + re-init en
     `shopify:section:load` para el editor de temas.
   Todo lo demás es idéntico al original.
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════
     ⚙️ CONFIGURACIÓN — se edita en Shopify:
     Personalizar → Configuración del tema → Contacto y redes
     ═══════════════════════════════════════════════════ */
  const CONFIG = window.RANITAS_CONFIG || {};
  /* Sin valores por defecto a propósito: si el número de WhatsApp no está
     configurado en los ajustes del tema, los enlaces se quedan en "#" en vez
     de mandar a los clientes a un número falso. */
  /* ═══════════════════════════════════════════════════ */

  /* Saneado del número de WhatsApp — GEMELO EXACTO de snippets/wa-numero.liquid.
     El dueño escribe (o PEGA) el número a mano en el editor de temas y lo normal es
     que lo haga como se lee ("+51 999 888 777"), y wa.me no admite ni '+' ni espacios.
     Se sanea por LISTA BLANCA: se conservan SOLO los dígitos 0-9. Antes esto era una
     lista de caracteres prohibidos (espacio, '+', '-', '(', ')') y se le colaba todo
     lo que un número pegado desde los contactos o desde WhatsApp Web trae de serie:
     espacio duro (U+00A0), espacio fino (U+202F), guion no separable (U+2011)… \D
     los descarta todos, igual que el bucle sobre '0123456789' del snippet, así que el
     href que escribe el servidor y el que reescribe este script llevan el mismo
     número sea cual sea el adorno. */
  function waSanea(valor){
    return String(valor == null ? '' : valor).replace(/\D+/g, '');
  }
  function waNumero(){
    return waSanea(CONFIG.whatsapp);
  }

  /* Codificado del mensaje — GEMELO EXACTO del "| url_encode | replace: '+','%20'"
     que usan las secciones. Liquid (url_encode == CGI.escape de Ruby) escapa todo
     lo que no sea A-Za-z0-9_.-~ y deja el espacio como '+', que el replace vuelve
     %20. encodeURIComponent hace lo mismo salvo cinco caracteres que deja tal cual
     y url_encode sí escapa: ! ' ( ) *  — de estos, el que aparece de verdad en los
     mensajes es el paréntesis del precio, "(S/ 60)". Percent-encodeándolos aquí,
     los dos lados producen la MISMA URL carácter a carácter, y da igual si un href
     lo escribió el servidor o lo reescribió este script. */
  function waEncode(texto){
    return encodeURIComponent(String(texto)).replace(/[!'()*]/g, function(c){
      return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
  }

  // ¿Hay un número de WhatsApp configurado en los ajustes del tema?
  // (Se comprueba sobre el número YA saneado: si alguien dejó escrito solo "+" o
  //  un par de espacios, eso no es un número y los enlaces deben quedarse en "#".)
  function waConfigurado(){
    return waNumero() !== '';
  }

  // ¿Hay correo para recibir las reseñas (FormSubmit) en los ajustes del tema?
  function correoResenas(){
    return String(CONFIG.correoResenas || '').trim();
  }

  /* La cantidad y el precio de cada pack los escribe el dueño a mano en el editor de
     temas, así que pueden llegar vacíos ('' → +'' es 0, no NaN) o con letras. Un pack
     de 0 unidades a S/ 0 no existe: los bloques que no traigan dos números mayores
     que 0 se ignoran y se conservan los valores vigentes. */
  function esNumeroPositivo(valor){
    const n = Number(valor);
    return isFinite(n) && n > 0;
  }

  /* Precio que va ESCRITO dentro del mensaje. Es un texto, no un número, porque el
     servidor lo pinta con settings.precio_base ("S/ 60") y aquí hay que partir del
     MISMO valor: antes esto era un 60 escrito a mano y, como refreshWa() reescribe
     el href de todos los .js-wa en cuanto carga el JS, en las páginas sin #bundle
     (producto, carrito, páginas sueltas) el mensaje volvía a decir "S/ 60" aunque el
     dueño hubiera subido el precio en el ajuste — el ajuste solo se notaba si el JS
     no cargaba. Sin | strip ni recortes: se copia el ajuste tal cual, que es lo que
     hace Liquid, para que servidor y cliente escriban el mismo mensaje. */
  let qty = 1, precioTxt = CONFIG.precioBase == null ? '' : String(CONFIG.precioBase);

  /* Precio de un pack concreto (bloque de #bundle o botón del dúo). Manda el texto
     data-price-label, que es el precio TAL COMO lo ve el cliente en la web ("S/ 100"
     en el pack de 2) y el mismo que pinta Liquid en ese enlace; data-price (número)
     queda de respaldo si esa etiqueta viniera vacía. Ojo: data-price sigue siendo el
     que decide si el pack es válido (esNumeroPositivo), así que aquí ya es un número. */
  function precioDePack(el){
    const etiqueta = el.dataset.priceLabel;
    if (etiqueta != null && etiqueta !== '') return etiqueta;
    return 'S/ ' + Number(el.dataset.price);
  }

  // Mensaje prellenado de WhatsApp (cambia según 1 o 2 Ranitas)
  function waMensaje(q, p){
    return `Hola Ranitas 🐸 Quiero pedir ${q === 1 ? '1 Ranita' : q + ' Ranitas'} (${p}). ¿Me envían los datos de Yape para pagar?`;
  }
  function waLink(q, p){
    if (!waConfigurado()) return '#';
    return `https://wa.me/${waNumero()}?text=${waEncode(waMensaje(q == null ? qty : q, p == null ? precioTxt : p))}`;
  }
  function refreshWa(){
    document.querySelectorAll('.js-wa').forEach(a=>{ a.href = waLink(); });
    refreshBuy();
  }

  /* Botón «Comprar ahora» del hero (.js-buy). El href GET a /cart/add ya funciona
     sin JavaScript con la cantidad del primer pack; aquí solo (1) se mantiene esa
     cantidad al día cuando el cliente cambia de pack y (2) al hacer clic se usa
     /cart/update.js para FIJAR la cantidad exacta en vez de sumarla — con /cart/add,
     volver atrás y hacer clic otra vez dejaba 2, 4, 6… unidades acumuladas en el
     carrito. Si el fetch falla se navega el href y el peor caso vuelve a ser ese. */
  function refreshBuy(){
    document.querySelectorAll('.js-buy').forEach(a=>{
      const vid = a.dataset.variant;
      if (!vid) return;
      /* data-qty-fixed: botones con cantidad propia (el banner del dúo siempre
         agrega 2), que no siguen al pack elegido en el hero. */
      const cantidad = () => a.dataset.qtyFixed ? Number(a.dataset.qtyFixed) : qty;
      a.href = '/cart/add?id=' + vid + '&quantity=' + cantidad() + '&return_to=/cart';
      if (a.dataset.rinitBuy) return;
      a.dataset.rinitBuy = '1';
      a.addEventListener('click', e => {
        if (!window.fetch) return;
        e.preventDefault();
        const updates = {};
        updates[vid] = cantidad();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => { window.location.href = '/cart'; })
          .catch(() => { window.location.href = a.href; });
      });
    });
  }

  // Estado compartido entre inits (el editor puede recargar secciones sueltas):
  // Los tres cierres devuelven true SOLO si su capa estaba abierta y la han cerrado:
  // así Escape puede cerrar únicamente la de encima.
  let cerrarDrawer = null;             // los asigna initDrawer / initReviewModal /
  let cerrarModal = null;              // initLightbox; el listener global de Escape
  let cerrarLightbox = null;           // usa siempre el DOM vigente
  let docListenersListos = false;      // flag: listeners de document UNA sola vez
  let rTimerVivo = null;               // timer vigente del carrusel de testimonios del hero
  let rsTimerVivo = null;              // timer vigente del carrusel de reseñas con fotos
  let rsPararTimer = function () {};   // los asigna initReviews; los usa el lightbox
  let rsReiniciarTimer = function () {};

  // Listeners a nivel document (Escape cierra lo que haya abierto), una sola vez
  function initDocListeners() {
    if (docListenersListos) return;
    docListenersListos = true;
    // Escape cierra SOLO la capa de encima, de la más alta a la más baja:
    // lightbox de fotos → modal de reseñas → menú lateral. Cerrar de golpe todas
    // hacía que Escape con una foto ampliada reseteara el formulario de reseñas
    // (perdiendo lo que el cliente estaba escribiendo) y dejara la foto abierta.
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if (cerrarLightbox && cerrarLightbox()) return;
      if (cerrarModal && cerrarModal()) return;
      if (cerrarDrawer) cerrarDrawer();
    });
    // Sin número configurado los enlaces de WhatsApp se quedan en "#": un clic no
    // debe navegar a ninguna parte. Sin JS ya no abren nada (Liquid no les pone
    // target="_blank" mientras no haya número), y con JS este listener evita además
    // el salto al inicio de la página que provoca un href="#".
    // Cubre los .js-wa y los botones de WhatsApp que NO llevan esa clase porque su
    // mensaje es propio (#btnDuo, #shopxWaBtn, los del carrito): esos van marcados
    // con data-wa. Cualquier otro enlace de la web sigue navegando como siempre
    // («Inicio» del menú lateral, por ejemplo, que también apunta a "#").
    document.addEventListener('click', e => {
      const t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      const a = t.closest('a');
      if (!a) return;
      if (a.classList.contains('js-wa') && !waConfigurado()) { e.preventDefault(); return; }
      if (a.hasAttribute('data-wa') && a.getAttribute('href') === '#') { e.preventDefault(); return; }
      if (a.getAttribute('href') === '#' && a.getAttribute('target') === '_blank') e.preventDefault();
    });
  }

  // Botón del dúo: siempre pide su propia cantidad/precio (data-qty / data-price)
  function initBtnDuo() {
    const btnDuo = document.getElementById('btnDuo');
    if (!btnDuo || btnDuo.dataset.rinit) return;
    btnDuo.dataset.rinit = '1';
    const q = btnDuo.dataset.qty, p = btnDuo.dataset.price;
    // Sin cantidad o precio válidos no se puede armar el mensaje ("0 Ranitas (S/ 0)"):
    // se deja el href que ya escribió Liquid en el servidor.
    if (!esNumeroPositivo(q) || !esNumeroPositivo(p)) return;
    btnDuo.href = waLink(Number(q), precioDePack(btnDuo));
  }

  // Rellenar datos de contacto (asignaciones idempotentes: se repiten en cada init)
  // (Los datos de Yape NO se publican en la web: se envían solo por chat.)
  // (El usuario de TikTok lo pinta Liquid en el servidor, ya con el '@' normalizado:
  //  reescribirlo aquí con el valor crudo del ajuste desincronizaba texto y enlace.)
  function initWa() {
    refreshWa();
  }

  // Menú lateral (el botón vive en el header y el drawer en el footer-group:
  // El scroll del body queda bloqueado mientras CUALQUIERA de las dos capas que lo
  // bloquean (menú lateral y modal de reseñas) siga abierta. Cada capa recalcula en
  // lugar de limpiar a ciegas: cerrar el modal con el menú abierto detrás devolvía
  // el scroll teniendo todavía una capa encima. El lightbox no entra aquí porque en
  // el diseño original tampoco bloqueaba el scroll.
  function ajustarScrollBody() {
    const bloquea = ['drawer', 'mrOverlay'].some(id => {
      const el = document.getElementById(id);
      return el && el.classList.contains('open');
    });
    document.body.style.overflow = bloquea ? 'hidden' : '';
  }

  // cada uno lleva su propia marca rinit porque el editor los recarga por separado)
  function initDrawer() {
    const drawer = document.getElementById('drawer');
    const drawerOverlay = document.getElementById('drawerOverlay');
    const menuBtn = document.getElementById('menuBtn');
    const drawerClose = document.getElementById('drawerClose');
    if (!drawer || !drawerOverlay || !menuBtn) return;
    // Los nodos se resuelven en el momento del clic, no al registrar el listener:
    // el editor puede recargar el footer-group (drawer y overlay nuevos) sin
    // recargar el header, y el #menuBtn de siempre debe abrir el drawer vigente.
    function abrirMenu(abrir) {
      const d = document.getElementById('drawer');
      const ov = document.getElementById('drawerOverlay');
      const btn = document.getElementById('menuBtn');
      if (d) d.classList.toggle('open', abrir);
      if (ov) ov.classList.toggle('open', abrir);
      if (btn) btn.setAttribute('aria-expanded', abrir);
      ajustarScrollBody();
    }
    // Devuelve true solo si el menú estaba abierto: Escape no debe restaurar el scroll
    // del body (ni tocar nada) cuando lo que está abierto es el modal o el lightbox.
    cerrarDrawer = () => {
      const d = document.getElementById('drawer');
      if (!d || !d.classList.contains('open')) return false;
      abrirMenu(false);
      return true;
    };
    if (!menuBtn.dataset.rinit) {
      menuBtn.dataset.rinit = '1';
      menuBtn.addEventListener('click', () => abrirMenu(true));
    }
    if (!drawer.dataset.rinit) {
      drawer.dataset.rinit = '1';
      if (drawerClose) drawerClose.addEventListener('click', () => abrirMenu(false));
      drawerOverlay.addEventListener('click', () => abrirMenu(false));
      // TODOS los enlaces del menú, no solo los del <nav>: el CTA de WhatsApp es
      // hermano del <nav> y sin esto el menú se quedaba abierto detrás de la
      // pestaña nueva de WhatsApp.
      drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => abrirMenu(false)));
    }
  }

  // Selector de bundle (precios desde los data-attributes de cada opción)
  function initBundle() {
    const bundle = document.getElementById('bundle');
    if (!bundle || bundle.dataset.rinit) return;
    bundle.dataset.rinit = '1';
    // Una sola función de selección. El guard de .selected evita duplicar la
    // actualización: al pulsar el <label> el navegador dispara el click del label, el
    // click reenviado al radio (que vuelve a burbujear) y el 'change' del radio — los
    // tres llaman aquí, pero solo el primero encuentra la opción sin .selected.
    function seleccionar(opt){
      if (!opt || opt.classList.contains('selected')) return;
      // Pack sin cantidad o sin precio numérico (el dueño vació el campo en el editor):
      // se ignora el bloque entero y siguen vigentes el pack y los precios de antes,
      // en vez de mandar por WhatsApp «0 Ranitas (S/ 0)». El radio vuelve al pack
      // vigente para que no quede marcado uno que no se ha aplicado.
      if (!esNumeroPositivo(opt.dataset.qty) || !esNumeroPositivo(opt.dataset.price)) {
        const vigente = bundle.querySelector('.bundle-opt.selected input[type="radio"]');
        if (vigente) vigente.checked = true;
        return;
      }
      bundle.querySelectorAll('.bundle-opt').forEach(o=>o.classList.remove('selected'));
      opt.classList.add('selected');
      const radio = opt.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;   // mantiene el radio en sync (clics programáticos)
      qty = Number(opt.dataset.qty); precioTxt = precioDePack(opt);
      const stickyPrice = document.getElementById('stickyPrice');
      const stickyOld = document.getElementById('stickyOld');
      const stickyOff = document.getElementById('stickyOff');
      // El precio de la barra fija nunca puede quedarse en blanco: si el bloque no
      // trae texto de precio se conserva el que ya se veía. El precio anterior y el
      // descuento SÍ pueden ir vacíos a propósito (un pack sin rebaja), así que solo
      // se salta la escritura si el data-attribute no existe (evita un "undefined").
      if (stickyPrice && opt.dataset.priceLabel) stickyPrice.textContent = opt.dataset.priceLabel;
      if (stickyOld && opt.dataset.old != null) stickyOld.textContent = opt.dataset.old;
      if (stickyOff && opt.dataset.off != null) stickyOff.textContent = opt.dataset.off;
      refreshWa();
    }
    bundle.querySelectorAll('.bundle-opt').forEach(opt=>{
      opt.addEventListener('click',()=>seleccionar(opt));
      // 'change' cubre el teclado: con las flechas el radio cambia sin que haya click
      const radio = opt.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change',()=>seleccionar(opt));
    });
    // Estado inicial: la opción marcada como .selected en el HTML
    // (si ese bloque no trae números válidos se queda el estado inicial:
    //  1 Ranita al precio del ajuste «Precio de 1 Ranita», settings.precio_base)
    const sel = bundle.querySelector('.bundle-opt.selected');
    if (sel && esNumeroPositivo(sel.dataset.qty) && esNumeroPositivo(sel.dataset.price)) {
      qty = Number(sel.dataset.qty); precioTxt = precioDePack(sel);
    }
  }

  // Carrusel de reseñas del hero — los datos vienen del JSON #htData (Liquid)
  function initHeroTesti() {
    const heroTesti = document.getElementById('heroTesti');
    const htSlide = document.getElementById('htSlide');
    const htDots = document.getElementById('htDots');
    const htData = document.getElementById('htData');
    if (!heroTesti || !htSlide || !htDots || !htData) return;
    if (heroTesti.dataset.rinit) return;
    heroTesti.dataset.rinit = '1';
    clearInterval(rTimerVivo); // por si el editor recargó la sección con un timer previo vivo

    let RESENAS = [];
    try { RESENAS = JSON.parse(htData.textContent) || []; } catch (err) { RESENAS = []; }
    if (!RESENAS.length) return;

    let rIdx = 0, rTimer = null;

    RESENAS.forEach((_, i) => {
      const d = document.createElement('button');
      d.className = 'ht-dot' + (i === 0 ? ' on' : '');
      d.setAttribute('aria-label', `Ver reseña ${i + 1}`);
      d.addEventListener('click', () => { mostrarResena(i); reiniciarTimer(); });
      htDots.appendChild(d);
    });

    function pintarResena(i) {
      const r = RESENAS[i];
      document.getElementById('htAvatar').textContent = r.ini;
      document.getElementById('htTexto').textContent = r.texto;
      document.getElementById('htNombre').textContent = r.nombre;
      htDots.querySelectorAll('.ht-dot').forEach((d, j) => d.classList.toggle('on', j === i));
    }
    function mostrarResena(i) {
      if (i === rIdx) return;
      rIdx = i;
      htSlide.classList.add('out');
      setTimeout(() => { pintarResena(rIdx); htSlide.classList.remove('out'); }, 350);
    }
    function reiniciarTimer() {
      clearInterval(rTimer);
      rTimer = setInterval(() => mostrarResena((rIdx + 1) % RESENAS.length), 5000);
      rTimerVivo = rTimer;
    }
    pintarResena(0);
    reiniciarTimer();
    heroTesti.addEventListener('mouseenter', () => clearInterval(rTimer));
    heroTesti.addEventListener('mouseleave', reiniciarTimer);
  }

  // Carrusel de videos (modelo peek): activo centrado, autoplay silencioso al entrar en vista
  function initVideoCarousel() {
    const videos = document.getElementById('videos');
    const vcTrack = document.getElementById('vcTrack');
    const vcDotsWrap = document.getElementById('vcDots');
    const vcPrev = document.getElementById('vcPrev');
    const vcNext = document.getElementById('vcNext');
    if (!videos || !vcTrack || !vcDotsWrap || !vcPrev || !vcNext) return;
    if (vcTrack.dataset.rinit) return;
    vcTrack.dataset.rinit = '1';

    const vcCards = [...vcTrack.children];
    if (!vcCards.length) return;
    let vIdx = 0, vSeccionVisible = false;

    vcCards.forEach((c, i) => {
      const d = document.createElement('button');
      d.className = 'vc-dot' + (i === 0 ? ' on' : '');
      d.setAttribute('aria-label', `Ver video ${i + 1}`);
      d.addEventListener('click', () => vcIr(i));
      vcDotsWrap.appendChild(d);

      c.addEventListener('click', e => {
        if (i !== vIdx) { vcIr(i); return; }      // click en un lateral: lo trae al centro
        vcToggleSonido(c);                        // click en el activo: alterna el sonido
        e.stopPropagation();
      });
      c.querySelector('video').addEventListener('ended', () => vcIr((vIdx + 1) % vcCards.length));
    });

    function vcPos() {
      const card = vcCards[0].offsetWidth;
      const centro = vcTrack.parentElement.clientWidth / 2 - card / 2;
      vcTrack.style.transform = `translateX(${centro - vIdx * (card + 18)}px)`;
    }
    function vcIr(i) {
      const prev = vcCards[vIdx].querySelector('video');
      prev.pause(); prev.muted = true;
      vIdx = (i + vcCards.length) % vcCards.length;
      vcCards.forEach((c, j) => c.classList.toggle('on', j === vIdx));
      vcDotsWrap.querySelectorAll('.vc-dot').forEach((d, j) => d.classList.toggle('on', j === vIdx));
      vcPos(); vcIconos(); vcPlay();
    }
    function vcPlay() {
      if (!vSeccionVisible) return;
      vcCards[vIdx].querySelector('video').play().catch(() => {});
    }
    function vcToggleSonido(c) {
      const v = c.querySelector('video');
      v.muted = !v.muted;
      if (v.paused) v.play().catch(() => {});
      vcIconos();
    }
    function vcIconos() {
      vcCards.forEach(c => {
        const v = c.querySelector('video');
        c.querySelector('.vc-sound').textContent = v.muted ? '🔇' : '🔊';
      });
    }
    vcPrev.addEventListener('click', () => vcIr(vIdx - 1));
    vcNext.addEventListener('click', () => vcIr(vIdx + 1));

    let vTouchX = null;
    vcTrack.addEventListener('touchstart', e => vTouchX = e.touches[0].clientX, { passive: true });
    vcTrack.addEventListener('touchend', e => {
      if (vTouchX === null) return;
      const dx = e.changedTouches[0].clientX - vTouchX;
      if (Math.abs(dx) > 40) vcIr(vIdx + (dx < 0 ? 1 : -1));
      vTouchX = null;
    }, { passive: true });

    new IntersectionObserver(entradas => {
      entradas.forEach(en => {
        vSeccionVisible = en.isIntersecting;
        if (en.isIntersecting) { vcPlay(); }
        else { vcCards.forEach(c => c.querySelector('video').pause()); }
      });
    }, { threshold: .35 }).observe(videos);

    window.addEventListener('resize', vcPos);
    vcPos(); vcIconos();
  }

  // Carrusel de reseñas con fotos (modelo peek, gemelo del de videos)
  function initReviews() {
    const rsTrack = document.getElementById('rsTrack');
    const rsDots = document.getElementById('rsDots');
    const rsPrev = document.getElementById('rsPrev');
    const rsNext = document.getElementById('rsNext');
    if (!rsTrack || !rsDots || !rsPrev || !rsNext) return;
    if (rsTrack.dataset.rinit) return;
    rsTrack.dataset.rinit = '1';
    clearInterval(rsTimerVivo); // por si el editor recargó la sección con un timer previo vivo

    const rsCards = [...rsTrack.children];
    if (!rsCards.length) return;
    let rsIdx = 0, rsTimer = null;

    rsCards.forEach((c, i) => {
      const d = document.createElement('button');
      d.className = 'rs-dot' + (i === 0 ? ' on' : '');
      d.setAttribute('aria-label', `Ver reseña ${i + 1}`);
      d.addEventListener('click', () => { rsIr(i); rsReinicio(); });
      rsDots.appendChild(d);
      c.addEventListener('click', () => { if (i !== rsIdx) { rsIr(i); rsReinicio(); } });
    });

    function rsPos() {
      const card = rsCards[0].offsetWidth;
      const centro = rsTrack.parentElement.clientWidth / 2 - card / 2;
      rsTrack.style.transform = `translateX(${centro - rsIdx * (card + 18)}px)`;
    }
    function rsIr(i) {
      rsIdx = (i + rsCards.length) % rsCards.length;
      rsCards.forEach((c, j) => c.classList.toggle('on', j === rsIdx));
      rsDots.querySelectorAll('.rs-dot').forEach((d, j) => d.classList.toggle('on', j === rsIdx));
      rsPos();
    }
    function rsReinicio() {
      clearInterval(rsTimer);
      rsTimer = setInterval(() => rsIr(rsIdx + 1), 5000);
      rsTimerVivo = rsTimer;
    }
    rsPrev.addEventListener('click', () => { rsIr(rsIdx - 1); rsReinicio(); });
    rsNext.addEventListener('click', () => { rsIr(rsIdx + 1); rsReinicio(); });

    let rsTouchX = null;
    rsTrack.addEventListener('touchstart', e => rsTouchX = e.touches[0].clientX, { passive: true });
    rsTrack.addEventListener('touchend', e => {
      if (rsTouchX === null) return;
      const dx = e.changedTouches[0].clientX - rsTouchX;
      if (Math.abs(dx) > 40) { rsIr(rsIdx + (dx < 0 ? 1 : -1)); rsReinicio(); }
      rsTouchX = null;
    }, { passive: true });

    const rsViewport = rsTrack.parentElement;
    rsViewport.addEventListener('mouseenter', () => clearInterval(rsTimer));
    rsViewport.addEventListener('mouseleave', rsReinicio);
    window.addEventListener('resize', rsPos);
    rsPos();
    rsReinicio();

    // El lightbox (misma sección) necesita pausar/reanudar este timer
    rsPararTimer = () => clearInterval(rsTimer);
    rsReiniciarTimer = rsReinicio;
  }

  // Modal "escribir un comentario": estrellas + texto + nombre → se envía por correo (FormSubmit)
  function initReviewModal() {
    const mrOverlay = document.getElementById('mrOverlay');
    const btnResena = document.getElementById('btnResena');
    const mrStarsWrap = document.getElementById('mrStars');
    const mrClose = document.getElementById('mrClose');
    const mrTexto = document.getElementById('mrTexto');
    const mrFoto = document.getElementById('mrFoto');
    const mrSend = document.getElementById('mrSend');
    const mrListo = document.getElementById('mrListo');
    if (!mrOverlay || !btnResena || !mrStarsWrap || !mrTexto || !mrFoto || !mrSend || !mrListo) return;
    if (mrOverlay.dataset.rinit) return;
    mrOverlay.dataset.rinit = '1';

    const mrStars = [...mrStarsWrap.children];
    let mrSel = 0;
    function mrPinta(n, color) { mrStars.forEach((s, i) => s.style.color = i < n ? (color || '#f5a623') : '#d5e0cd'); }
    mrStars.forEach((s, i) => {
      s.addEventListener('mouseenter', () => mrPinta(i + 1));
      s.addEventListener('click', () => { mrSel = i + 1; mrPinta(mrSel); });
    });
    mrStarsWrap.addEventListener('mouseleave', () => mrPinta(mrSel));
    // Rótulo en reposo del selector de foto: el MISMO texto que pinta la sección en
    // Liquid. Vive en una constante porque lo restauran dos sitios (quitar la foto y
    // el reset al cerrar) y tienen que decir exactamente lo mismo.
    const MR_FOTO_TXT = '📷 Añadir una foto de tu Ranita';
    mrTexto.addEventListener('input', () => {
      const cuenta = document.getElementById('mrCount');
      if (cuenta) cuenta.textContent = mrTexto.value.length;
    });
    mrFoto.addEventListener('change', () => {
      const caja = document.querySelector('.mr-file');
      const rotulo = document.getElementById('mrFileTxt');
      if (!caja || !rotulo) return;
      if (mrFoto.files[0]) { rotulo.textContent = `✓ ${mrFoto.files[0].name}`; caja.classList.add('con-foto'); }
      else { rotulo.textContent = MR_FOTO_TXT; caja.classList.remove('con-foto'); }
    });
    // Aviso de error de envío: se crea por JS (la sección no trae markup para esto).
    // motivo 'red'    → el envío falló y reintentar puede funcionar.
    // motivo 'config' → la tienda no tiene correo de reseñas configurado:
    //                   reintentar NUNCA va a funcionar, así que no se invita a ello.
    // mrEnvio identifica el envío vigente: sube en cada envío y en cada reset, así una
    // respuesta que llega tarde (el cliente cerró el modal mientras la petición estaba
    // en vuelo) se reconoce como abandonada y no toca el formulario nuevo.
    let mrError = null, mrEnviando = false, mrEnvio = 0;
    function mrMostrarError(motivo) {
      if (!mrError) {
        mrError = document.createElement('div');
        mrError.setAttribute('role', 'alert');
        mrError.style.cssText = 'margin-top:12px;padding:12px 14px;border-radius:12px;background:var(--green-soft);border:1px solid var(--green);color:var(--ink);font-size:.85rem;line-height:1.6;text-align:center';
        mrSend.insertAdjacentElement('afterend', mrError);
      }
      // Se repinta en cada aviso: el mismo cuadro sirve para los dos motivos
      while (mrError.firstChild) mrError.removeChild(mrError.firstChild);
      const hayWa = waConfigurado();
      const aviso = document.createElement('p');
      aviso.style.cssText = 'margin:0;color:var(--green-dark);font-weight:600';
      const ayuda = document.createElement('p');
      ayuda.style.cssText = 'margin:6px 0 0;color:var(--gray)';
      if (motivo === 'config') {
        aviso.textContent = 'Todavía no podemos recibir reseñas por aquí 🐸';
        ayuda.textContent = hayWa
          ? 'El formulario aún no está habilitado, así que volver a pulsar no va a funcionar. Cuéntanos tu experiencia por WhatsApp y la publicamos nosotros.'
          : 'El formulario aún no está habilitado y ahora mismo no tenemos otra vía de contacto, así que volver a pulsar no va a funcionar. Perdona las molestias: lo estamos arreglando.';
      } else {
        aviso.textContent = 'No pudimos enviar tu reseña 🐸';
        ayuda.textContent = 'Revisa tu conexión y vuelve a pulsar «Publicar reseña».';
      }
      mrError.appendChild(aviso);
      mrError.appendChild(ayuda);
      if (hayWa) {
        const alt = document.createElement('a');
        alt.className = 'js-wa';
        alt.href = waLink();
        alt.target = '_blank';
        alt.rel = 'noopener';
        alt.style.cssText = 'display:inline-block;margin-top:8px;color:var(--green-dark);font-weight:600;text-decoration:underline';
        alt.textContent = motivo === 'config' ? 'Escríbenos por WhatsApp' : 'O cuéntanoslo por WhatsApp';
        mrError.appendChild(alt);
      }
      mrError.style.display = '';
    }
    function mrOcultarError() { if (mrError) mrError.style.display = 'none'; }

    // Botón «Publicar reseña» mientras la petición está en vuelo: deshabilitado para
    // que no se pueda enviar dos veces. En reposo se le borran las dos propiedades
    // inline y el aria-*, así que vuelve a ser EXACTAMENTE el que pinta .mr-send.
    function mrSendOcupado(ocupado) {
      mrSend.disabled = !!ocupado;
      mrSend.style.opacity = ocupado ? '.65' : '';
      mrSend.style.cursor = ocupado ? 'progress' : '';
      if (ocupado) mrSend.setAttribute('aria-busy', 'true');
      else mrSend.removeAttribute('aria-busy');
    }

    // Reset del formulario: TODO o NADA. Antes unas líneas comprobaban el nodo y otras
    // no, así que si faltaba uno la función lanzaba a mitad del reset y el formulario
    // se quedaba medio limpio. Ahora se resuelven todos los nodos primero.
    function mrResetear() {
      // El envío que estuviera en vuelo queda abandonado: se le retira el token (su
      // respuesta ya no tocará nada) y se libera el botón, que si no se quedaba muerto
      // para siempre — «Publicar reseña» no hacía absolutamente nada al reabrir.
      mrEnvio++;
      mrEnviando = false;
      mrSendOcupado(false);
      mrOcultarError();
      const form = document.getElementById('mrForm');
      const gracias = document.getElementById('mrGracias');
      const rotulo = document.getElementById('mrFileTxt');
      const caja = document.querySelector('.mr-file');
      const nombre = document.getElementById('mrNombre');
      const cuenta = document.getElementById('mrCount');
      if (!form || !gracias || !rotulo || !caja || !nombre || !cuenta) return;
      form.style.display = '';
      gracias.style.display = 'none';
      mrFoto.value = '';
      rotulo.textContent = MR_FOTO_TXT;
      caja.classList.remove('con-foto');
      mrSel = 0;
      mrPinta(mrSel);   // estrellas apagadas (mismo color que trae .mr-stars)
      mrTexto.value = '';
      nombre.value = '';
      cuenta.textContent = '0';
    }

    function mrAbrir(abrir) {
      mrOverlay.classList.toggle('open', abrir);
      ajustarScrollBody();
      // Al cerrar se resetea TODO el formulario: si no, tras un envío correcto el
      // modal se reabría con la reseña anterior escrita y las estrellas encendidas,
      // invitando a enviar lo mismo dos veces.
      if (!abrir) mrResetear();
    }
    // Solo cierra (y resetea) si el modal estaba abierto de verdad: con Escape, la capa
    // de encima puede ser el lightbox, y entonces este formulario no se toca.
    cerrarModal = () => {
      if (!mrOverlay.classList.contains('open')) return false;
      mrAbrir(false);
      return true;
    };
    btnResena.addEventListener('click', e => { e.preventDefault(); mrAbrir(true); });
    if (mrClose) mrClose.addEventListener('click', () => mrAbrir(false));
    mrOverlay.addEventListener('click', e => { if (e.target === mrOverlay) mrAbrir(false); });
    mrSend.addEventListener('click', () => {
      if (mrSel === 0) { mrPinta(5, '#e33d3d'); setTimeout(() => mrPinta(mrSel), 700); return; }
      if (mrEnviando) return;
      const correo = correoResenas();
      if (!correo) { mrMostrarError('config'); return; }
      const nodoNombre = document.getElementById('mrNombre');
      const nodoHoney = document.getElementById('mrHoney');
      const texto = mrTexto.value.trim() || 'Sin comentario';
      const nombre = (nodoNombre ? nodoNombre.value.trim() : '') || 'Cliente Ranitas';
      // Envío a tu correo vía FormSubmit (con foto adjunta si la hay)
      const fd = new FormData();
      fd.append('_subject', `Nueva reseña Ranitas: ${mrSel}/5 de ${nombre}`);
      fd.append('_template', 'table');
      fd.append('_captcha', 'false');
      fd.append('_honey', nodoHoney ? nodoHoney.value : '');
      fd.append('Calificación', `${'★'.repeat(mrSel)}${'☆'.repeat(5 - mrSel)} (${mrSel} de 5)`);
      fd.append('Comentario', texto);
      fd.append('Nombre', nombre);
      const foto = mrFoto.files[0];
      if (foto) fd.append('Foto', foto, foto.name);
      // El bloque de gracias se muestra SOLO si el envío llegó de verdad
      mrOcultarError();
      mrEnviando = true;
      mrSendOcupado(true);
      // Token de ESTE envío. Si el cliente cierra el modal mientras la petición está en
      // vuelo, el reset lo invalida y todo lo de abajo se descarta: la respuesta vieja
      // ya no puede ocultar el formulario nuevo ni tirar lo que esté escribiendo.
      const envio = ++mrEnvio;
      fetch(`https://formsubmit.co/ajax/${encodeURIComponent(correo)}`, { method: 'POST', body: fd })
        .then(res => {
          if (envio !== mrEnvio) return;            // envío abandonado
          if (!res || !res.ok) throw new Error('Envío rechazado');
          const form = document.getElementById('mrForm');
          const gracias = document.getElementById('mrGracias');
          if (form) form.style.display = 'none';
          if (gracias) gracias.style.display = 'block';
        })
        .catch(() => { if (envio === mrEnvio) mrMostrarError('red'); })
        .then(() => { if (envio === mrEnvio) { mrEnviando = false; mrSendOcupado(false); } });
    });
    mrListo.addEventListener('click', () => mrAbrir(false));
  }

  // Lightbox: click en una foto de la reseña activa la muestra a pantalla completa
  function initLightbox() {
    const rsLb = document.getElementById('rsLightbox');
    const rsLbImg = document.getElementById('rsLightboxImg');
    const rsTrack = document.getElementById('rsTrack');
    if (!rsLb || !rsLbImg || !rsTrack) return;
    if (rsLb.dataset.rinit) return;
    rsLb.dataset.rinit = '1';
    rsTrack.querySelectorAll('.rs-fotos img').forEach(img => {
      img.addEventListener('click', e => {
        const tarjeta = img.closest('.rs-card');
        if (!tarjeta || !tarjeta.classList.contains('on')) return; // los laterales solo se centran
        e.stopPropagation();
        rsLbImg.src = img.src;
        rsLb.classList.add('open');
        rsPararTimer();
      });
    });
    // Un solo camino de cierre (fondo, ✕ o Escape): quita la foto y reanuda el carrusel.
    // Devuelve true solo si había una foto abierta, para que Escape cierre el lightbox
    // y AHÍ SE PARE, sin arrastrar consigo el reset del formulario de reseñas.
    function lbCerrar() {
      if (!rsLb.classList.contains('open')) return false;
      rsLb.classList.remove('open');
      rsReiniciarTimer();
      return true;
    }
    cerrarLightbox = lbCerrar;
    rsLb.addEventListener('click', () => { lbCerrar(); });
    // El ✕ tiene su propio manejador en vez de depender del burbujeo hasta el fondo
    const rsLbCerrar = rsLb.querySelector('.lb-cerrar');
    if (rsLbCerrar) rsLbCerrar.addEventListener('click', e => { e.stopPropagation(); lbCerrar(); });
  }

  // Galería del hero: los thumbs ya vienen renderizados por Liquid
  // (solo existen si hay más de 1 foto); el JS únicamente les da el click
  function initGallery() {
    const thumbs = document.getElementById('thumbs');
    const mainImg = document.getElementById('mainImg');
    if (!thumbs || !mainImg) return;
    if (thumbs.dataset.rinit) return;
    thumbs.dataset.rinit = '1';
    thumbs.querySelectorAll('img').forEach(t => {
      t.addEventListener('click', () => {
        mainImg.src = t.src;
        thumbs.querySelectorAll('img').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
      });
    });
  }

  // La burbuja flotante de WhatsApp se esconde mientras el pie está en pantalla:
  // en móvil se montaba encima de los enlaces de las políticas y los tapaba.
  // Vuelve a aparecer sola al subir. Si el navegador no soporta IntersectionObserver
  // (o no hay pie), la burbuja se queda visible como siempre.
  function initFlotanteEnPie() {
    const flotante = document.querySelector('.wsp-float');
    const pie = document.querySelector('footer');
    if (!flotante || !pie || typeof IntersectionObserver === 'undefined') return;
    if (flotante.dataset.rinitPie) return;
    flotante.dataset.rinitPie = '1';
    new IntersectionObserver(entradas => {
      entradas.forEach(en => {
        flotante.classList.toggle('ranitas-oculto', en.isIntersecting);
      });
    }, { threshold: 0 }).observe(pie);
  }

  function initAll() {
    initDocListeners();
    initFlotanteEnPie();
    initDrawer();
    initBundle();     // antes de initWa: fija qty/precioTxt según la opción .selected
    initBtnDuo();
    initWa();
    initGallery();
    initHeroTesti();
    initVideoCarousel();
    initReviews();    // antes de initLightbox: expone el control del timer
    initLightbox();
    initReviewModal();
  }

  initAll(); // el script carga con defer: el DOM ya está listo
  document.addEventListener('shopify:section:load', () => initAll());
})();
